import sanityClient from '@sanity/client';

export const sanity = sanityClient({
  // TODO: use environment variables
  projectId: 't9lanjpn',
  dataset: 'production',
  useCdn: true,
});
